import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSliderChange } from '@angular/material/slider';

import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'ui-slider-control',
	templateUrl: './slider-control.component.html',
	styleUrls: ['../../styles/form-controls.less', './slider-control.component.less'],
})
export class SliderControlComponent implements OnInit {
	@Input() form: FormGroup;
	@Input() form_control: FormControl;
	@Input() label: string = null;
	@Input() placeholder: string = null;
	@Input() info: string = null;
	@Input() highlighted_info: boolean = false;
	@Input() display_value: string = '';
	@Input() min: number = 0;
	@Input() step: number = 1;
	@Input() max: number = 1;
	@Input() invert: boolean = false;
	@Input() disabled: boolean = false;
	@Input() loading: boolean = false;
	@Input() prefix: string = null;
	@Input() suffix: string = null;

	@Output() changed = new EventEmitter();
	@Output() input = new EventEmitter();

	form_control_id: string = '';
	form_control_name: string = '';
	last_emitted_value: number = null;
	is_focused: boolean = false;

	constructor(private helper_service: HelperService) {}

	ngOnInit(): void {
		let form_control_name = null;
		const parent = this.form_control.parent;

		if (parent instanceof FormGroup) {
			Object.keys(parent.controls).forEach((name) => {
				if (this.form_control === parent.controls[name]) {
					form_control_name = name;
				}
			});
		}

		this.form_control_name = form_control_name;
		this.form_control_id = 'slider_' + this.helper_service.generateRandomString(30);
	}

	onSliderInput(event: MatSliderChange): void {
		this.form_control.setValue(event.value);
		this.input.emit(event);
	}

	onFocus(): void {
		this.is_focused = true;
	}

	onBlur(): void {
		this.is_focused = false;
		if (this.form_control.dirty) {
			this.roundValue();
		}
	}

	roundValue(): void {
		let new_value: number;
		if (this.form_control.value < this.min) {
			new_value = this.min;
		} else if (this.form_control.value > this.max) {
			new_value = this.max;
		} else {
			new_value = Math.round(this.form_control.value / this.step) * this.step;
		}
		this.setValue(new_value);
	}

	setValue(value): void {
		this.form_control.setValue(value);
		if (this.last_emitted_value !== value) {
			this.changed.emit(value);
			this.last_emitted_value = value;
		}
	}
}
